<template>
  <div class="block commonPage">
    <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :page-sizes="[10, 20, 30,50]"
        :page-size="params.size"
        :current-page="params.current"
        layout="total, prev, pager, next,sizes, jumper"
        :total="params.total"
        background
    >
    </el-pagination>
  </div>
</template>

<script>

export default {
  name: "bottomPagination",
  props: {
    params: {
      size: 0,
      current: 1,
      total: 0,
    },
  },
  methods: {
    sizeChange(val) {
      this.$emit('sizeChange', val);
    },
    currentChange(val) {
      this.$emit('currentChange', val);
    },
  }
}
</script>

<style scoped>
.commonPage {
  position: absolute;
  right: 2vh;
  bottom: 0vh;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
